import { audienceModalStyles } from '@bingads-webui-campaign-react/common-styles';

export const getFallbackPageStyles = (_, { palette = {} }) => ({
  container: {
    marginLeft: '23px',
    marginTop: '16px',
  },
  bodyContainer: {
    paddingTop: '10px',
    width: '232px',
  },
  '@global': audienceModalStyles({ palette }),
});
